// extracted by mini-css-extract-plugin
module.exports = {"daysList":"styles_daysList__24nbf","todayContainer":"styles_todayContainer__183-h","separatorParagraph":"styles_separatorParagraph__gnBHO","noProgress":"styles_noProgress__3eprB"};